import { Card, FormControl, Grid, MenuItem, Select, TextField } from '@material-ui/core';
import React from 'react';
import useCareerInterestStyles from './CareerInterestSubsection.styles';
import { CAREER_INTEREST_OPTIONS, CAREER_INTEREST_SUBSECTION_FIELDS } from '../../../constants/general';

const CareerInterestSubsection = (props) => {
  const { item, data, setData, fieldDisabled } = props;
  const classedStyles = useCareerInterestStyles();
  return (
    <Card sx={{ width: '90%' }} className={classedStyles.box + ' ' + classedStyles[item.key]}>
      {CAREER_INTEREST_SUBSECTION_FIELDS.map((field) => {
        if (field.key === 'program') {
          return (
            <React.Fragment key={field.key}>
              <Grid
                container
                direction="row"
                className={classedStyles.fieldSpacing + ' ' + classedStyles.unprintedContent}
                style={{ alignItems: 'center' }}
              >
                <Grid item xs={12}>
                  <label
                    className={classedStyles.bold}
                    style={{ fontWeight: 'bold' }}
                    id={`career-interest-program-${item.key}`}
                    htmlFor={`career-interest-program-${item.key}`}
                  >
                    {item.name}
                  </label>
                </Grid>
              </Grid>
            </React.Fragment>
          );
        }
        if (field.key === 'educationOrTrainingNeeded') {
          return (
            <React.Fragment key={field.key}>
              <Grid
                container
                direction="row"
                className={classedStyles.fieldSpacing + ' ' + classedStyles.unprintedContent}
                style={{ alignItems: 'center' }}
              >
                <Grid item xs={12} sm={12} md={5} lg={3}>
                  <label id={`career-interest-label-${item.key}`} htmlFor={`career-interest-select-${item.key}`}>
                    {field.label}
                  </label>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4}>
                  <FormControl fullWidth>
                    <Select
                      variant="outlined"
                      labelId={`career-interest-select-${item.key}`}
                      id={`career-interest-select-${item.key}`}
                      value={data[field.key] || ''}
                      onChange={(event) => setData({ ...data, [field.key]: event.target.value })}
                      displayEmpty
                      disabled={fieldDisabled}
                      className={classedStyles.textFieldBackground}
                    >
                      <MenuItem value="" disabled>
                        Select
                      </MenuItem>
                      {CAREER_INTEREST_OPTIONS.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
              <div className={classedStyles.printedContent}>
                <Grid container direction="row" className={classedStyles.printedContent}>
                  <Grid item xs={4}>
                    <label className={classedStyles.alignPrintedContent}>{item.name}</label>
                  </Grid>
                  <Grid item xs={8}>
                    <summary className={classedStyles.alignPrintedContent}>
                      {CAREER_INTEREST_OPTIONS.find((opt) => opt.value === data[field.key])?.label || null}
                    </summary>
                  </Grid>
                </Grid>
              </div>
            </React.Fragment>
          );
        }
        // default
        return (
          <Grid container direction="row" key={field.key} className={classedStyles.fieldSpacing}>
            <Grid container direction="row" className={classedStyles.unprintedContent}>
              <Grid item xs={12}>
                <label htmlFor={field.key}>{field.label}</label>
              </Grid>
            </Grid>
            <Grid container direction="row">
              <Grid item xs={12} className={classedStyles.unprintedContent}>
                <FormControl fullWidth>
                  <TextField
                    id={field.key}
                    variant="outlined"
                    value={data[field.key] || ''}
                    onChange={(e) => setData({ [field.key]: e.target.value.slice(0, field.maxLength) })}
                    disabled={fieldDisabled}
                    hiddenLabel
                    fullWidth
                    multiline
                    minRows={field.minRows}
                    inputProps={{ maxLength: field.maxLength, className: classedStyles.textField }}
                    className={classedStyles.textFieldBackground}
                  />
                </FormControl>
              </Grid>
            </Grid>
            <div className={classedStyles.printedContent}>
              <div>
                <label className={classedStyles.alignPrintedContent}>{field.label}</label>
              </div>
              <div>
                <summary className={classedStyles.alignPrintedContent}>{data[field.key] || null}</summary>
              </div>
            </div>
          </Grid>
        );
      })}
    </Card>
  );
};

export default CareerInterestSubsection;
